import React, { useState } from 'react';
import { useMetadata } from '../../context/MetadataContext';
import { useGameState } from '../../context/GameStateContext';
import { useGlobalError } from '../../context/GlobalErrorContext';
import { getValue } from '../../utils/getValue';
import FormattedTime from '../../utils/FormattedTime';
import Fireworks from 'react-canvas-confetti/dist/presets/fireworks';
import LeaderboardModal from '../LeaderboardModal';
import { 
  Home,            // Close/Home
  List,            // Leaderboard
  Search           // Find another
} from 'lucide-react';

const TournamentResults = () => {
  const { getText } = useMetadata();
  const { gameData, rejectPuzzle, findTournamentPuzzle } = useGameState();
  const { triggerError } = useGlobalError();
  const [isLeaderboardOpen, setIsLeaderboardOpen] = useState(false);


  if (!gameData?.state) {
    triggerError({
      type: 'non-critical',
      message: getText('errors.request_failed'),
      error: new Error('Missing game state data')
    });
    return null;
  }


  const handlePlayAgain = () => {
    findTournamentPuzzle(gameData.state.tournament_key);
  };

  const onCloseResults = () => {
    rejectPuzzle();
  };

  const handleShowLeaderboard = () => {
    setIsLeaderboardOpen(true);
  };

  const handleCloseLeaderboard = () => {
    setIsLeaderboardOpen(false);
  };

  return (
    <div className="dataContainer">
      <Fireworks autorun={{ speed: 1, duration: 2000 }} />
      <div className="containerHeader">
        <h3>{getText('tournament_mode.your_results')}</h3>
      </div>
      
      <div className="dataContent">
        <div className="contentGroup">
          
        <div className="dataRow">
            <span className="dataLabel">{getText('common_text.total_time')}:</span>
            <span className="dataValue"><FormattedTime seconds={getValue(gameData,'state.total_time',0)} /></span>
          </div>
          <div className="subDataRow">
            <span className="subDataLabel">{getText('common_text.clock_time')}:</span>
            <span className="subDataValue"><FormattedTime seconds={getValue(gameData,'state.clock_time',0)} /></span>
          </div>
          
          <div className="subDataRow">
            <span className="subDataLabel">
              {getText('common_text.penalty_time')} ({getText('common_text.hints').toLowerCase()} {getValue(gameData,'state.hint_count')}):
           </span>
            <span className="subDataValue">
              <FormattedTime seconds={getValue(gameData, 'state.penalty_time')} />
            </span>
          </div>

          <div className="dataRow">
            <span className="dataLabel">{getText('common_text.moves')}:</span> 
            <span className="dataValue">{getValue(gameData,'state.move_count')}</span>
          </div>

        </div>
        


        <div className="contentGroup">
                  <div className="dataRow">
                    <span className="dataLabel">{getText('tournament_mode.progress')}:</span>
                    <span className="dataValue">
                      {getValue(gameData, 'stats.user_finished_count', 0)} / {getValue(gameData, 'stats.puzzle_count', 0)}
                    </span>
                  </div>
        
                  
                  <div className="progressBarContainer">
                    <div 
                      className="progressBar" 
                      style={{ width: `${getValue(gameData, 'stats.user_finished_percent', 0)}%` }}
                    ></div>
                  </div>
                </div>
                
                <div className="contentGroup">
                  <div className="dataRow">
                    <span className="dataLabel">{getText('tournament_mode.participants')}:</span>
                    <span className="dataValue">{getValue(gameData, 'stats.player_count', 0)}</span>
                  </div>
                  
                  <div className="dataRow">
                    <span className="dataLabel">{getText('tournament_mode.finished_players')}:</span>
                    <span className="dataValue">
                      {getValue(gameData, 'stats.finished_player_count', 0)} ({getValue(gameData, 'stats.finished_player_percent', 0)}%)
                    </span>
                  </div>
                  
                  {getValue(gameData, 'stats.expires_ts') && (
                    <div className="dataRow">
                      <span className="dataLabel">{getText('tournament_mode.expires')}:</span>
                      <span className="dataValue">
                        {new Date(getValue(gameData, 'stats.expires_ts') * 1000).toLocaleDateString()}
                      </span>
                    </div>
                  )}
                </div>
              </div>
      
        <div className="actionButtonContainer">
          <button 
            className="iconButton secondaryButton" 
            onClick={onCloseResults}
            title={getText('common_text.close')}
            aria-label={getText('common_text.close')}
          >
            <Home className="buttonIcon" />
          </button>
          <button 
            className="iconButton secondaryButton" 
            onClick={handleShowLeaderboard}
            title={getText('common_text.leaderboard')}
            aria-label={getText('common_text.leaderboard')}
          >
            <List className="buttonIcon" />
          </button>
          <button 
            className="iconButton primaryButton" 
            onClick={handlePlayAgain}
            title={getText('common_text.find_another')}
            aria-label={getText('common_text.find_another')}
          >
            <Search className="buttonIcon" />
          </button>
      </div>
      
      <LeaderboardModal 
        isOpen={isLeaderboardOpen}
        onClose={handleCloseLeaderboard}
        tournamentKey={getValue(gameData, 'state.tournament_key')}
      />
    </div>
  );
};

export default TournamentResults;
